import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import PageTitle from "../../PageTitle";
import {CommandBarButton, MessageBarType, PrimaryButton, TextField} from "office-ui-fabric-react";
import moment from "moment";
import ApiService from "../../ApiService";
import Actions from "../../../redux/Actions";
import { AccountInfo } from '@azure/msal-browser';
import * as _ from 'lodash';
import LinkCard from "../../LinkCard";
import {Link} from "react-router-dom";
import {MailroomTimingAnalysisCard} from "../../mailroom/MailroomTimingAnalysisCard";

interface DevUtilsPageProps {
    user: AccountInfo | undefined,
    apiService: ApiService
}

interface DevUtilsPageState {
    schoolCode: string;
    sdsSchoolId: string;
    loadTestSchoolCount: string;
}

export const DEV_TENANT_ID = "96acd487-a2c4-4abf-b052-d90f765ca677";

class DevUtilsPage extends Component<DevUtilsPageProps & DispatchProps, DevUtilsPageState> {
    static displayName = DevUtilsPage.name;

    constructor(props: DevUtilsPageProps & DispatchProps) {
        super(props);

        this.state = {
            schoolCode: "",
            sdsSchoolId: "",
            loadTestSchoolCount: "10"
        }
    }

    async componentDidMount() {
        this.resetSchoolCodeAndSdsId();
    }

    async componentDidUpdate(prevProps: Readonly<DevUtilsPageProps & DispatchProps>, prevState: any): Promise<void> {
    }

    private resetSchoolCodeAndSdsId() {
        if (this.props.user) {
            const nameParts = _.split(this.props.user.name!, " ");
            const firstInitial = nameParts[0][0];
            const secondInitial = nameParts[1] ? nameParts[1][0] : firstInitial;
            const date = moment().format("YYYYMMDDHHmmss");

            this.setState({
                schoolCode: firstInitial + secondInitial + date
            });
        }
        else {
            this.setState({
                schoolCode: ""
            });
        }
        
        this.setState({sdsSchoolId: ""});
    }

    private createDevSchool = async (): Promise<void> => {

        if (!this.state.schoolCode || !this.state.sdsSchoolId) {
            return;
        }

        try {
            await this.props.apiService.devCreateSchool(this.state.schoolCode,this.state.sdsSchoolId);
            this.props.dispatch(Actions.showMessageBar(`Created ${this.state.schoolCode} successfully`, MessageBarType.success));
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar("Failed to create dev school", MessageBarType.error));
        }
    }

    private buildDevSchool = async (): Promise<void> => {

        if (!this.state.schoolCode) {
            return;
        }

        try {
            await this.props.apiService.devBuildSchool(this.state.schoolCode);
            this.props.dispatch(Actions.showMessageBar(`Built ${this.state.schoolCode} successfully`, MessageBarType.success));
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar("Failed to build dev school", MessageBarType.error));
        }
    }
    
    private generateDevSalamanderPassword = async (): Promise<void> => {

        if (!this.state.schoolCode) {
            return;
        }

        try {
            const password = await this.props.apiService.generateDevSalamanderPassword(this.state.schoolCode);
            this.props.dispatch(Actions.showMessageBar(`Password for ${this.state.schoolCode} is : ${password}`, MessageBarType.success));
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar(`Failed to generate salamander password for ${this.state.schoolCode}`, MessageBarType.error));
        }
        
    }
    
    private startLoadTest = async (): Promise<void> => {
        try {
            await this.props.apiService.devStartWorkloadsLoadTest(this.state.loadTestSchoolCount);
            this.props.dispatch(Actions.showMessageBar(`Started workloads load test using ${this.state.loadTestSchoolCount} schools`, MessageBarType.success));
        }
        catch (e) {
            this.props.dispatch(Actions.showMessageBar("Failed to start workloads load test", MessageBarType.error));
        }
    }

    private clearWorkloadTenantLocks = async (): Promise<void> => {
        await this.props.apiService.clearWorkloadTenantLocks();
    }
    
    render() {
        return (
            <Fragment>
                <PageTitle title={"Dev Utils"}/>


                <div className={"flex-row"}>
                    <LinkCard title={"Status"} to={`/dev/status`} iconName={"NetworkTower"} description={"View application status"}/>
                </div>

                <div className={"flex-row"}>
                    <LinkCard title={"Audit Logs"} to={`/dev/auditLogs`} iconName={"ComplianceAudit"}
                              description={"View audit logs"}/>
                </div>
                <div className={"flex-row"}>
                    <LinkCard title={"Mailroom Bulk Processor Comparison"}
                              to={`/cdb-admin/mailroom/bulk-processor-comparison`} iconName={"MailOptions"}
                              description={"Verify processor behaviour using customer data"}/>
                    <LinkCard title={"Mailroom Reports"} to={`/cdb-admin/mailroom/reports`} iconName={"Generate"}
                              description={"Generate Mailroom reports"}/>
                    <LinkCard title={"Mailroom Automations"} to={`/cdb-admin/mailroom/automation/history`}
                              iconName={"List"} description={"View all automation details in mailroom"}/>
                </div>
                <div className={"flex-row"}>
                    <LinkCard title={"Durable Function Browser"} to={`/cdb-admin/durable-functions/instances`}
                              iconName={"BulletedList"} description={"Browse durable function instances"}/>
                </div>
                <div className={"flex-row"}>
                    <LinkCard title={"Freshdesk Sync"} to={`/cdb-admin/freshdesk/sync`} iconName={"Sync"}
                              description={"View status and manage Freshdesk sync"}/>
                </div>
                <div className={"flex-row"}>
                    <LinkCard title={"Container Images"} to={`/cdb-admin/container-images`} iconName={"Tag"}
                              description={"Manage container images"}/>
                </div>

                <div className="card">
                    <div className="card__header">
                        <span className={"card__title"}>Generate School</span>
                    </div>
                    <div className="card__content flex-column ">


                        <div className={"flex-row"}>
                            <span>1a. Ensure Licenses available (Use LicenseReclaimer if necessary)</span>
                        </div>
                        <div className={"flex-row"}>
                            <span>1b. Use UserGenerator to create users with licenses</span>
                        </div>

                        <div className={"flex-row flex--align-items-flex-end"}>
                            <span>2a.</span>
                            <TextField className="card__input"
                                       label="School code"
                                       disabled={false}
                                       value={this.state.schoolCode}
                                       onChange={(_, value) => {
                                           this.setState({
                                               schoolCode: value!
                                           });
                                       }}/>

                            <PrimaryButton onClick={this.generateDevSalamanderPassword}
                                           text={`Generate Salamander Password`}/>
                        </div>
                        <br/>


                        <div className={"flex-row"}>
                            <span>2b.Send school data to inbox using DevOpsSchoolGenerator</span>
                        </div>

                        <div className={"flex-row flex--align-items-flex-end"}>
                            <span>3.</span>
                            <TextField className="card__input"
                                       label="School code"
                                       disabled={false}
                                       value={this.state.schoolCode}
                                       onChange={(_, value) => {
                                           this.setState({
                                               schoolCode: value!
                                           });
                                       }}/>

                            <TextField className="card__input"
                                       label="SDS School id"
                                       disabled={false}
                                       value={this.state.sdsSchoolId}
                                       onChange={(_, value) => {
                                           this.setState({
                                               sdsSchoolId: value!
                                           });
                                       }}/>

                            <PrimaryButton onClick={this.createDevSchool} text={`Create school and mailroom config`}/>

                        </div>
                        <br/>

                        <div className={"flex-row"}>
                            <Link to={`/cdb-admin/mailroom/${DEV_TENANT_ID}/${this.state.schoolCode}`}>
                                <span>4.Configure mailroom and send to sds</span>
                            </Link>
                        </div>

                        <div className={"flex-row flex--align-items-flex-end"}>
                            <span>5.</span>
                            <TextField className="card__input"
                                       label="School code"
                                       disabled={false}
                                       value={this.state.schoolCode}
                                       onChange={(_, value) => {
                                           this.setState({
                                               schoolCode: value!
                                           });
                                       }}/>

                            <PrimaryButton onClick={this.buildDevSchool}
                                           text={`Build school (workload config, service account and run DevGenerateSchool playlist)`}/>

                        </div>
                    </div>
                </div>

                <div className="card">
                    <div className="card__header">
                        <span className={"card__title"}>Start LoadTest Workloads</span>

                        <CommandBarButton
                            iconProps={{iconName: "TestPlan"}}
                            text="Start Load Test"
                            disabled={false}
                            onClick={this.startLoadTest}
                        />
                    </div>
                    <div className="card__content flex-column">
                        <TextField className="card__input"
                                   label="School count"
                                   disabled={false}
                                   value={this.state.loadTestSchoolCount}
                                   onChange={(_, value) => {
                                       this.setState({
                                           loadTestSchoolCount: value!
                                       });
                                   }}/>
                    </div>
                </div>
                
                <MailroomTimingAnalysisCard apiService={this.props.apiService} />


                <div className="card">
                    <div className="card__header">
                        <span className={"card__title"}>Functions locks</span>
                    </div>
                    <div className="card__content flex-column">
                        <PrimaryButton onClick={this.clearWorkloadTenantLocks} text={`Clear workload tenantLocks`} />
                    </div>
                </div>

            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState): DevUtilsPageProps => {
        return {
            user: state.auth.user,
            apiService: state.auth.apiService
        };
    }
)(DevUtilsPage)